import IntentUserApprovalModal from "app/pages/sales-intelligence/sub-modules/intent/components/IntentUserApprovalModal";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import { selectIntentSelectedTopics } from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import { fetchSelectedIntentTopicsThunk } from "app/pages/sales-intelligence/sub-modules/intent/store/management/effects/effects";
import useIntentUserApprovedAction from "app/pages/sales-intelligence/sub-modules/intent/hooks/useIntentUserApprovedAction";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

const IntentApprovalContainer = () => {
    const dispatch = useDispatch();
    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const { isOpenApprovalModal, onClickUserApprovedTerms } = useIntentUserApprovedAction();

    useEffect(() => {
        if (salesSettingsHelper.isIntentSignalsEnabled()) {
            void dispatch(fetchSelectedIntentTopicsThunk());
        }
    }, []);

    if (
        !salesSettingsHelper.isIntentSignalsEnabled() ||
        selectedTopics.length === 0 ||
        siNavigator.isAccountSignalsManagementPage ||
        siNavigator.isIntentSignalsManagementPage
    ) {
        return null;
    }

    return (
        <IntentUserApprovalModal
            isOpen={isOpenApprovalModal}
            onClick={onClickUserApprovedTerms}
        />
    );
};

export default IntentApprovalContainer;
